/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

/**
 * A module representing a subscription error.
 * @module utilities/errors/subscription
 */
"use strict";

var util = require("util");
var WError = require("verror").WError;

/**
 * Represents a subscription error.
 *
 * @constructor
 * @param {Error|null} cause - The underlying error that caused this one.
 * @param {String} message - A custom error message.
 */
function SubscriptionError(cause, message) {
  this.name = "SubscriptionError";
  this.message = message || "Error regarding your subscription.";

  Error.captureStackTrace(this, this.constructor);
  if (cause) {
    this.cause(cause);
  }
}
util.inherits(SubscriptionError, WError);

/**
 * Represents a subscription limit reached error.
 *
 * @constructor
 * @param {Error|null} cause - The underlying error that caused this one.
 * @param {String} message - A custom error message.
 * @param {String} propertyName - What limit was reached.
 */
function SubscriptionLimitReachedError(cause, message, propertyName) {
  this.name = "SubscriptionLimitReachedError";
  this.message = message || "Subscription limit reached.";
  this.propertyName = propertyName;

  Error.captureStackTrace(this, this.constructor);
  if (cause) {
    this.cause(cause);
  }
}
util.inherits(SubscriptionLimitReachedError, SubscriptionError);

module.exports = exports = SubscriptionError;

SubscriptionError.SubscriptionLimitReachedError = SubscriptionLimitReachedError;


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/utilities/lib/errors/subscription.js
// module id = 870
// module chunks = 6